import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Shim requerido por @syncfy/authentication-widget (doc oficial): en builds
// modernos (webpack5/Vite) `global` no existe en el browser y el widget lo
// referencia internamente -> "ReferenceError: global is not defined".
if (typeof window !== "undefined" && typeof window.global === "undefined") {
  window.global = window;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
